import { useCallback, useState } from 'react';

const useVideoJSAds = () => {
  const [videoJsGoogleImaPluginLoaded, setVideoJsGoogleImaPluginLoaded] = useState(false);

  const [videoJsGoogleImaPluginError, setVideoJsGoogleImaPluginError] = useState(false);

  const onVideoJsGoogleImaLoaded = useCallback(() => setVideoJsGoogleImaPluginLoaded(true), []);

  const onVideoJsGoogleImaError = useCallback((e: any) => {
    // this error is expected if the user is using an ad blocker so we won't report it to NewRelic
    setVideoJsGoogleImaPluginError(true);
    console.error('onVideoJsGoogleImaError', e);
  }, []);

  return {
    videoAdPluginsLoaded: videoJsGoogleImaPluginLoaded,
    isVideoAdPluginsError: videoJsGoogleImaPluginError,
    onVideoJsGoogleImaLoaded,
    onVideoJsGoogleImaError,
    setVideoJsGoogleImaPluginError,
  };
};

export default useVideoJSAds;
